module.exports = "/images/vessel-4.jpg";